export const STATUS_META = {
    draft: { label: "Bozza", cls: "bg-slate-100 text-slate-800 border-slate-200" },
    received: { label: "Ricevuta", cls: "bg-amber-100 text-amber-900 border-amber-200" },
    in_progress: { label: "In lavorazione", cls: "bg-sky-100 text-sky-900 border-sky-200" },
    answered: { label: "Risposta inviata", cls: "bg-emerald-100 text-emerald-900 border-emerald-200" },
    cancelled: { label: "Annullata", cls: "bg-rose-100 text-rose-900 border-rose-200" },
};

export function StatusBadge({ status }) {
    const m = STATUS_META[status] || STATUS_META.received;
    return (
        <span
            className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-semibold border ${m.cls}`}
            data-testid={`status-badge-${status}`}
        >
            {m.label}
        </span>
    );
}

export function formatDate(iso) {
    if (!iso) return "—";
    try {
        return new Date(iso).toLocaleDateString("it-IT", {
            day: "2-digit", month: "short", year: "numeric", hour: "2-digit", minute: "2-digit",
        });
    } catch { return iso; }
}

export function fileToDataUrl(file) {
    return new Promise((resolve, reject) => {
        const r = new FileReader();
        r.onload = () => resolve(r.result);
        r.onerror = reject;
        r.readAsDataURL(file);
    });
}
